import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RouteHappyResults } from '@sabstravtech/obtservices/base';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';

@Component({
  selector: 'app-routehappy-flight-modal',
  templateUrl: './routehappy-flight-modal.component.html',
  styleUrls: ['./routehappy-flight-modal.component.scss'],
  standalone: false
})
export class RoutehappyFlightModalComponent implements OnInit {
  results: RouteHappyResults = null;
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}
}

LightningModalTypes.RoutehappyFlightModalComponent.component = RoutehappyFlightModalComponent;
